<template>
	<div class="contentPage">
		<div class="calendarScroll">
			<div class="calendar">
				<div class="calendarLeft">
					<date-now v-once></date-now>
					<date-block v-once></date-block>
					<filter-block
							v-if="filterCalendarPayments"
							:filterCalendarPayments="filterCalendarPayments"
							:filters="filters"
							:isCreate="!permissions[getPermissionsConstants.CREATE]"
							@updateFilterField="onFilterField"
							@updateFilterReset="onFilterReset"
							@updateCreatePayments="onCreatePayments"
					></filter-block>
				</div>
				<div class="calendarRight">
					<calendar-header
							:filterDate="filterDate"
							@updateTime="onTime"
							@updateToday="onToday"
					></calendar-header>
					<calendar-content
							v-if="calendarDates"
							:calendarDates="calendarDates"
							:isPreload="isPreload"
							@updateDetailsPayments="onDetailsPayments"
					></calendar-content>
				</div>
			</div>
		</div>
		<create-payment
				v-if="isCreatePayments"
				@updateClose="onCreatePaymentsClose"
		></create-payment>
		<details-payments
				v-if="isDetailsPayments"
				:date="date"
				:isEdit="permissions[getPermissionsConstants.EDIT]"
				:isDelete="permissions[getPermissionsConstants.DELETE]"
				@updateClose="onDetailsPaymentsClose"
				@updateEditCalendar="onEditCalendar"
		></details-payments>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// static components
import DateNow from "@/components/Accounting/Calendar/DateNow/DateNow";
// components
import CalendarHeader from "@/components/Accounting/Calendar/CalendarHeader/CalendarHeader";
import CalendarContent from "@/components/Accounting/Calendar/CalendarContent/CalendarContent";
import CreatePayment from "@/components/Accounting/Calendar/CreatePayment/CreatePayment";
import DetailsPayments from "@/components/Accounting/Calendar/DetailsPayments/DetailsPayments";
import DateBlock from "@/pages/Accounting/Calendar/DateBlock/DateBlock";
import FilterBlock from "@/pages/Accounting/Calendar/FilterBlock/FilterBlock";
import getDefaultDate from "@/helper/getDefaultDate";
import debounce from "lodash.debounce";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "Calendar",
	components: {
		CalendarHeader,
		CreatePayment,
		DetailsPayments,
		CalendarContent,
		DateNow,
		DateBlock,
		FilterBlock
	},
	computed: {
		...mapGetters([ 'calendarDates', 'filterCalendarPayments', 'permissions' ]),
		getPermissionsConstants() {
			return PERMISSIONS;
		}
	},
	data: () => ({
		isPreload: false,
		date: '',
		filterDate: getDefaultDate(1),
		filters: {
			filter_customer: [],
			filter_driver: [],
			filter_truck: [],
			filter_payment: [],
		},
		isCreatePayments: false,
		isDetailsPayments: false
	}),
	methods: {
		...mapActions([ 'getCalendar', 'getCalendarOnDate' ]),
		onFilterField: debounce(async function({ value, key }) {
			this.isPreload = true;
			this.$set(this.filters, key, value);
			const [ years, month ] = this.filterDate.split('-');
			const date = `${ years }-${ month }-01`;
			await this.getCalendarOnDate({ month: date, ...this.filters });
			this.isPreload = false;
		}, 500),
		async onFilterReset() {
			this.isPreload = true;
			const [ years, month ] = this.filterDate.split('-');
			const date = `${ years }-${ month }-01`;
			this.filters = {
				filter_customer: [],
				filter_driver: [],
				filter_truck: [],
				filter_payment: [],
			};

			await this.getCalendarOnDate({ month: date, ...this.filters });
			this.isPreload = false;
		},
		onTime: debounce(async function(date) {
			this.isPreload = true;
			this.filterDate = getDefaultDate(1, date);
			await this.getCalendarOnDate({ month: date, ...this.filters });
			this.isPreload = false;
		}, 500),
		async onToday() {
			this.isPreload = true;
			this.filterDate = getDefaultDate(1);
			const defaultDate = getDefaultDate();
			const [ years, month ] = defaultDate.split('-');
			const date = `${ years }-${ month }-01`;
			await this.getCalendarOnDate({ month: date, ...this.filters });
			this.isPreload = false;
		},
		onDetailsPayments(date) {
			if (this.permissions[this.getPermissionsConstants.VIEW]) {
				this.date = date;
				this.isDetailsPayments = true;
			}
		},
		async onCreatePayments() {
			this.isCreatePayments = true;
		},
		async onCreatePaymentsClose() {
			this.isCreatePayments = false;
			this.isPreload = true;
			const [ years, month ] = this.filterDate.split('-');
			const date = `${ years }-${ month }-01`;
			await this.getCalendarOnDate({ month: date, ...this.filters });
			this.isPreload = false;
		},
		onDetailsPaymentsClose() {
			this.isDetailsPayments = false;
		},
		async onEditCalendar() {
			this.isPreload = true;
			const [ years, month ] = this.filterDate.split('-');
			const date = `${ years }-${ month }-01`;
			await this.getCalendarOnDate({ month: date, ...this.filters });
			this.isPreload = false;
		}
	},
	async mounted() {
		await this.getCalendar();
	}
};
</script>

<style scoped lang="scss">
@import "calendar";
</style>

<style lang="scss">
@import "calendar-all";
</style>
